import { lazyComponent } from './lazyWithPreload';

/**
 * UI that is not on the path to the first paint of the mail list, split into
 * chunks of its own (issue #208). Each is imported from here instead of from
 * its module, and renders exactly as before; see `lazyWithPreload.tsx`.
 *
 * **Keep every value import of these modules going through here.** One
 * static `import { X } from '…/ComposeDialog'` anywhere on the entry's import
 * graph pulls the whole module (and everything it imports) back into the
 * entry chunk, silently — the bundle budget (`npm run check:bundle`) is what
 * notices. `import type` is free.
 *
 * `prefetch.ts` warms these after the first paint, most likely first, so a
 * first press of `c`, `l`, `b`, Shift+T or Shift+S does not wait on the
 * network.
 */

// Compose, with the rich-text editor, recipients, AI assist, Nextcloud
// offer/picker and Send later it carries. The biggest single thing a cold
// start used to pay for without using.
export const ComposeDialog = lazyComponent(() => import('@/routes/mail/ComposeDialog'), 'ComposeDialog');

// Dialogs a mail verb opens.
export const LabelPicker = lazyComponent(() => import('@/features/labels/LabelPicker'), 'LabelPicker');
export const LabelDialog = lazyComponent(() => import('@/features/labels/LabelDialogs'), 'LabelDialog');
export const SnoozeDialog = lazyComponent(() => import('@/features/scheduling/SnoozeDialog'), 'SnoozeDialog');
export const AddToTaskDialog = lazyComponent(
  () => import('@/features/email-task/AddToTaskDialog'),
  'AddToTaskDialog',
);
export const BlockSenderDialog = lazyComponent(
  () => import('@/features/block-sender/BlockSenderDialog'),
  'BlockSenderDialog',
);
export const FolderDialog = lazyComponent(() => import('@/components/FolderDialog'), 'FolderDialog');
export const ShortcutSheet = lazyComponent(() => import('@/routes/mail/ShortcutSheet'), 'ShortcutSheet');
export const ContactEditor = lazyComponent(() => import('@/features/contacts/ContactEditor'), 'ContactEditor');

// Reading-pane extras that only some messages, or only a request, show.
export const MessageInviteCard = lazyComponent(
  () => import('@/routes/calendar/InviteCard'),
  'MessageInviteCard',
);
export const AiSummaryPanel = lazyComponent(
  () => import('@/features/ai-summary/AiSummaryPanel'),
  'AiSummaryPanel',
);
// The folder picker of Save to Nextcloud (ADR 0086): only once a person saves
// an attachment, from the reading pane, a conversation or the message window.
export const NextcloudFolderPicker = lazyComponent(
  () => import('@/features/nextcloud/NextcloudPicker'),
  'NextcloudFolderPicker',
);
